const bannerSwiper = new Swiper('.banner-slider', {
  loop: true,
  speed: 800, 
  // autoplay: {
  //   delay: 4000, 
  //   disableOnInteraction: false, 
  // },
  slidesPerView: 1, 
  spaceBetween: 0, 
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});
